import { Component, OnInit } from '@angular/core';
import { GroupService } from 'src/app/api/departure/group.service';
import { GlobalService } from 'src/app/api/global.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;
import * as _ from 'underscore';
import * as moment from 'moment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-group-report',
  templateUrl: './group-report.component.html',
  styleUrls: ['./group-report.component.css']
})
export class GroupReportComponent implements OnInit {
  private thisComponent: GroupReportComponent;
  branchofficeSlug: string = '';

  items: any = [];
  page = 1;
  count = 0;
  params: any = {
    search: '',
    tour_id: null
  };
  date_range: any = moment().format('YYYY-MM-DD');

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  constructor(
    private groupService: GroupService,
    private globalService: GlobalService,
    private router: Router,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    // Recuperar la vista almacenada en cookies
    this.list();
  }

  list() {
    let val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&date_range=' +
      this.date_range +
      '&tour_id=' +
      this.params.tour_id;
    this.groupService.listReportGroups(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
        // console.log(this.items);
      }
    });
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  balance(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reportes/salidas/grupos/balance/',
      id
    ]);
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reportes/lista']);
  }
}
